import React, { FC } from 'react';
import styled from 'styled-components';
import { CustomBlockContent } from './CustomBlockContent';
import { GreySection } from './GreySection';

interface InitialOpenReportProps {
  title: string;
  greyContent: string;
  toggle: () => void;
  _rawSummaryAfterGreyContent: any;
  _rawSummaryGreyContentAfterDivider: any;
  summaryImage: any;
  _rawSummaryAfterImage: any;
  _rawTextTwo: any;
  _rawTextThree: any;
  _rawTextFour: any;
  imageTwo: any;
  imageThree: any;
  imageFour: any;
}

export const InitialOpenReport: FC<InitialOpenReportProps> = ({
  title,
  greyContent,
  toggle,
  _rawSummaryAfterGreyContent,
  _rawSummaryGreyContentAfterDivider,
  summaryImage,
  _rawSummaryAfterImage,
  _rawTextTwo,
  _rawTextThree,
  _rawTextFour,
  imageTwo,
  imageThree,
  imageFour,
}) => {
  const firstImageUrl = summaryImage?.asset.url;
  const secondImageUrl = imageTwo?.asset.url;
  const thirdImageUrl = imageThree?.asset.url;
  const fourthImageUrl = imageFour?.asset.url;

  return (
    <>
      <GreySection title={title} content={greyContent} toggle={toggle} />
      <InitialOpenReportContainer>
        <div className="width-container">
          {_rawSummaryAfterGreyContent && (
            <div className="article-container">
              <article>
                <CustomBlockContent blocks={_rawSummaryAfterGreyContent} />
              </article>
            </div>
          )}
          {firstImageUrl && <img src={firstImageUrl} />}
          {_rawSummaryAfterImage && (
            <div className="article-container">
              <article>
                <CustomBlockContent blocks={_rawSummaryAfterImage} />
              </article>
            </div>
          )}
          <div className="divider"> </div>
          {_rawSummaryGreyContentAfterDivider && (
            <div className="article-container">
              <article>
                <CustomBlockContent
                  blocks={_rawSummaryGreyContentAfterDivider}
                />
              </article>
            </div>
          )}
          {secondImageUrl && <img src={secondImageUrl} />}
          {_rawTextTwo && (
            <div className="article-container">
              <article>
                <CustomBlockContent blocks={_rawTextTwo} />
              </article>
            </div>
          )}
          {thirdImageUrl && <img src={thirdImageUrl} />}
          {_rawTextThree && (
            <div className="article-container">
              <article>
                <CustomBlockContent blocks={_rawTextThree} />
              </article>
            </div>
          )}
          {fourthImageUrl && <img src={fourthImageUrl} />}
          {_rawTextFour && (
            <div className="article-container">
              <article>
                <CustomBlockContent blocks={_rawTextFour} />
              </article>
            </div>
          )}
        </div>
      </InitialOpenReportContainer>
    </>
  );
};

const InitialOpenReportContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: var(--white);

  .width-container {
    padding: 0 35px;
  }

  .button-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 25px;

    button {
      color: var(--white);
      padding: 10px 70px;
      margin-bottom: 7%;
      text-transform: uppercase;
    }
  }

  .article-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 25px 0;
    text-align: justify;
    @media (max-width: 600px) {
      &:last-child {
        margin-bottom: 40px;
      }
    }

    article {
      color: var(--black);
      line-height: 1.2em;
      column-count: 2;
      column-gap: 35px;
      font-size: 1em;
      column-width: 400px;

      word-wrap: break-word;
      @media (max-width: 868px) {
        font-size: 0.8em;
        column-count: 1;
        padding: 20px 0;
      }

      @media (max-width: 600px) {
        font-size: 0.8em;
        column-count: 1;
        padding: 0 0;
      }
    }
  }

  .divider {
    border-top: 1px solid var(--darkgrey);
    width: 100%;
    max-width: 1024px;
  }
`;
